import { styled } from 'styled-components';

import {
  Chip,
  ColorsV2,
  useThemeColors,
  IconNames,
  ChipProps,
} from '@electricjs/arc';

export type OutlineChipProps = {
  /** Unique identifier for the chip */
  id: string;
  /** Text content displayed in the chip */
  label: string;
  /** Color of the text content - uses theme colors */
  textColor?: string;
  /** Background color of the chip - uses theme colors */
  backgroundColor?: string;
  /** Color of the chip border/outline - uses theme colors */
  outlineColor?: string;
  /** Additional CSS class name */
  className?: string;
  /** Icon to display in the chip - uses IconNames from Arc library */
  icon?: IconNames;
  /** Visual variant of the chip - 'small' or 'medium' */
  variant?: ChipProps['variant'];
};

const OutlineChip = ({
  id,
  label,
  textColor,
  backgroundColor,
  outlineColor,
  className,
  icon,
  variant,
}: OutlineChipProps) => {
  const [defaultTextColor, defaultBackgroundColor, defaultOutlineColor] =
    useThemeColors([
      ColorsV2.PRIMARY,
      ColorsV2.PRIMARY_LIGHTEST,
      ColorsV2.PRIMARY,
    ]);

  if (!label) {
    return <></>;
  }

  const borderWidth = variant === 'small' ? '1.5px' : '2px';

  return (
    <Chip
      className={className}
      id={id}
      variant={variant}
      textColor={textColor || defaultTextColor}
      backgroundColor={backgroundColor || defaultBackgroundColor}
      border={`${borderWidth} solid ${outlineColor || defaultOutlineColor}`}
      icon={icon}>
      {label}
    </Chip>
  );
};

export default styled(OutlineChip)<OutlineChipProps>``;
export { OutlineChip };
